<template>
    <li>
        <a v-bind:href="item.Url.replace('~/','/')" v-bind:title="item.Title">
            <div class="person-listing-image">
                <img v-if="item.Image != ''" v-bind:src="item.Image" v-bind:alt="item.Title">
                <img v-if="item.Image == ''" src="/Content/images/person-avatar.png" v-bind:alt="item.Title">
            </div>
            <div class="person-listing-text">
                <p class="person-name">{{item.Title}}</p>
                <span class="person-title">{{item.BoardTitle}}</span>
                <span class="person-title">{{item.ChairTitle}}</span>
                <p class="person-title"><em>{{item.JobTitle}}</em></p>
                <p>{{item.Org}}</p>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: ['item'],
}
</script>